module.exports = __webpack_public_path__ + "img/矩形-亮.3af8064e.png";